export function includesNumber(str) {
    return /\d/.test(str);
  }